const ErrorMessage = (props) => {
    const {id, error} = props;
    return (
        <>
            <div className='govuk-form-group govuk-form-group--error'>
                <p id={`${id}-error`} className="error--message text-danger">
                    <span className="sr-only">Error:</span>
                    {error?.message}
                </p>
            </div>
        </>
    );
}

export default ErrorMessage;